import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { MenuItem } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { FuelType } from '../../../../generated/graphql'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function HeatBoilerForm({ control, errors }: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatBoiler.efficiency"
          rules={{
            ...validators.required,
            ...validators.efficiency,
          }}
          error={errors.parameters?.heatBoiler?.efficiency}
          label={t('createProvider.forms.heatBoiler.efficiency')}
          defaultValue="1"
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatBoiler.fuelType"
          rules={{
            ...validators.required,
          }}
          error={errors.parameters?.heatBoiler?.fuelType}
          label={t('createProvider.forms.heatBoiler.fuelType')}
          defaultValue={FuelType.Oil}
          select
        >
          {Object.values(FuelType).map((fuelType) => (
            <MenuItem key={fuelType} value={fuelType}>
              {t(`fuelType.${fuelType}`)}
            </MenuItem>
          ))}
        </ControlledTextField>
      </FormGroup>
    </>
  )
}
